import { useCallback, useEffect, useState } from 'react';

export function useAdminAutoRefresh({ enabled = true, intervalMs = 15000 } = {}) {
  const [refreshNonce, setRefreshNonce] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshNonce((current) => current + 1);
  }, []);

  useEffect(() => {
    if (!enabled || !intervalMs) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      if (document.visibilityState === 'visible') {
        triggerRefresh();
      }
    }, intervalMs);

    return () => window.clearInterval(intervalId);
  }, [enabled, intervalMs, triggerRefresh]);

  return {
    refreshNonce,
    triggerRefresh,
  };
}

export default useAdminAutoRefresh;
